<template>
  <div
    class="main-pop"
    :class="{ show: showPopups, 'main-pop--landscape': cellcardFramePotrait }"
  >
    <div
      :id="ids"
      class="box-modal"
      @click="function () {
          return false;
        }
      "
    >
      <div class="d-block text-center">
        <div class="close-pop" @click="hidePopup()">
          <svg width="24px" height="24px" viewBox="0 0 24 24">
            <g data-name="close">
              <rect
                width="24"
                height="24"
                transform="rotate(180 12 12)"
                opacity="0"
              />
              <path
                d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"
              />
            </g>
          </svg>
        </div>

        <!-- POP UP EMPTY SUBS -->
        <div v-if="ids === 'emptySubscription'">
          <b-img :src="dataPopup.image" center rounded class="img-box"></b-img>
          <h3 class="title-popup">{{ dataPopup.title }}</h3>
          <p class="txt-desc">{{ dataPopup.description }}</p>
          <b-button
            class="mt-3 btn-defaultx"
            block
            @click="actionButtonHome()"
            >{{ dataPopup.txtButton }}</b-button
          >
        </div>
        <!-- POP UP EMPTY SUBS -->

        <div v-if="ids === 'popupToken' || ids === 'popupReward'">
          <b-img :src="dataPopup.image" center rounded class="img-box"></b-img>
          <h3 class="title-popup">{{ dataPopup.title }}</h3>
          <p class="txt-desc">{{ dataPopup.description }}</p>
          <b-button class="mt-3 btn-defaultx" block @click="actionButton()">{{
            dataPopup.txtButton
          }}</b-button>
        </div>
        <div v-if="ids === 'popupInfo'" style="position: relative">
          <div class="inform">
            <SyaratAda />
            <b-button class="mt-3 btn-defaultx" block @click="hidePopup()">{{
              dataPopup.txtButton
            }}</b-button>
          </div>
        </div>
        <div v-if="ids === 'popupService'" style="position: relative">
          <div class="head-service"></div>
          <div class="service">
            <div class="list-store">
              <div v-for="lists in storeList" :key="lists.id" class="box-list">
                <div class="head-list">
                  <div class="head-list-desc">
                    <h3>Rp.{{ lists.service_charge }}</h3>
                    Untuk +{{ lists.token }} token
                  </div>
                </div>
                <div>{{ lists.description }}</div>
                <b-button
                  class="mt-1 btn-defaultx-list"
                  block
                  @click="actionPull(lists.channel, lists.keyword, lists.adn)"
                  >beli</b-button
                >
              </div>
            </div>
          </div>
        </div>

        <!-- POP UP LOGOUT -->
        <div v-if="ids === 'popupLogout'" class="popup-logout">
          <h3 class="title-popup">{{ dataPopup.title || "Logout" }}</h3>
          <p class="txt-desc">
            {{ dataPopup.description || "Are you sure you want to logout?" }}
          </p>
          <div class="logout-buttons">
            <b-button
              class="mt-3 btn-defaultx btn-cancel"
              block
              @click="hidePopup()"
              >{{ dataPopup.buttonCancel || "No" }}</b-button
            >
            <b-button
              class="mt-3 btn-defaultx btn-confirm"
              block
              @click="actionLogout()"
              >{{ dataPopup.txtButton || "Yes" }}</b-button
            >
          </div>
        </div>
        <!-- POP UP LOGOUT -->
      </div>
    </div>
    <div class="backdrop-pop" @click="hidePopup()" />
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import SyaratAda from "@/components/Syarat.vue";
export default {
  components: {
    SyaratAda,
  },
  data: function () {
    return {};
  },
  props: {
    dataPopup: Object,
    ids: String,
  },
  computed: {
    ...mapGetters({
      showPopups: "getPopupShow",
      storeList: "getStore",
      telco: "getTelco",
    }),
    ...mapState(["android", "cellcardFramePotrait"]),
  },
  methods: {
    ...mapMutations({
      setPopups: "SET_GAME_POPUP_SHOW",
    }),
    hidePopup() {
      this.setPopups(false);
      this.$router.push({ name: "play" });
    },
    actionButton() {
      //   this.$store.state.coin = 1
      // this.hidePopup(this.ids)
      this.setPopups(false);
      this.$emit("addCoin");
      console.log("clicked", this.$store.state.coin);
    },
    actionButtonHome() {
      this.setPopups(false);
      this.$emit("addCoin");

      this.$store.commit("SET_PRE_USER", null);
      this.$router.push({ name: "subscribe" });
    },
    actionLogout() {
      this.setPopups(false);
      this.$store.commit("SET_USER", null);
      this.$store.commit("SET_PRE_USER", null);
      this.$router.push({ name: "login" });
    },
    actionPull(channel, keyword, adn) {
      this.setPopups(false);
      if (this.android && window.androidExt) {
        if (channel === "SMS") {
          window.androidExt.postMessage(
            "{'methode':'sms','var_a':'" + adn + "','var_b':'" + keyword + "'}",
          );
        } else if (channel === "UMB") {
          // keyword = keyword.slice(0, keyword.length - 1), keyword += "%23";
          window.androidExt.postMessage(
            "{'methode':'umb','var_a':'" + keyword + "','var_b':'null'}",
          );
        } else if (channel === "WAP") {
          window.androidExt.postMessage(
            "{'methode':'wap','var_a':'http://117.54.3.23:1481/" +
              this.telco +
              "?aid=1&adn=" +
              adn +
              "&keyword=" +
              keyword +
              "','var_b':'null'}",
          );
        } else if (channel === "GPLAY") {
          keyword = keyword.slice(0, -2);
          window.androidExt.postMessage(
            "{'methode':'gplay','var_a':'" + keyword + "','var_b':'null'}",
          );
        } else {
          window.androidExt.postMessage(
            "{'methode':'msg','var_a':'SERVICE BELUM TERSEDIA','var_b':'null'}",
          );
        }
      } else {
        if (channel === "SMS") {
          location.href = "sms:" + adn + "?body=" + keyword;
        } else if (channel === "UMB") {
          keyword = keyword.slice(0, keyword.length - 1);
          keyword += "%23";
          location.href = "tel:" + keyword;
        } else if (channel === "WAP") {
          window.open(
            "http://117.54.3.23:1481/" +
              this.telco +
              "?aid=1&adn=" +
              adn +
              "&keyword=" +
              keyword +
              "",
            "_blank",
          );
        }
      }
    },
    callDataService() {
      console.log(this.storeList);
    },
    // showPopupHadiah(point) {
    //   const index = this.reward.findIndex(
    //     item => item.point === point
    //   );
    //   const reward = this.reward[index];
    //   this.dataPopup.image = reward.image;
    //   this.dataPopup.title = reward.title;
    //   this.dataPopup.description = reward.description;
    //   this.dataPopup.txtButton = "Ambil";
    //   this.$bvModal.show("popupModal");
    // },
    // showPopupValidateToken() {
    //   const token = this.token;
    //   this.dataPopup.image = token.image;
    //   this.dataPopup.title = token.title;
    //   this.dataPopup.description = token.description;
    //   this.dataPopup.txtButton = "Tambah Token";
    //   console.log('muncul', this.point);
    //   this.$bvModal.show("popupModal");
    //   // this.$refs['popupModal'].show()
    // },
    // setPopup() {
    //     if (this.totalPoint !== null) {
    //       if (this.totalPoint === '0') {
    //           this.showPopupValidateToken()
    //       } else {
    //           this.showPopupHadiah(this.totalPoint)
    //       }
    //   } else {
    //       this.$bvModal.hide("popupModal")
    //   }

    // },
  },
};
</script>
<style scoped>
.backdrop-pop {
  width: 100vw;
  height: 100vh;
  background: #0000009e;
  position: relative;
  z-index: 1001;
}
.main-pop {
  display: none;
}
.main-pop.show {
  display: block;
}
.box-modal {
  color: #fff !important;
  background: #1a169bab;
  border: 1px solid #2300ff69;
  width: 50vw;
  height: calc(100vh - 3rem);
  min-width: 15rem !important;
  max-width: 30rem;
  margin: auto;
  position: absolute;
  z-index: 1002;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 1rem;
  border-radius: 9px;
  box-shadow: #000000c2 1px 1px 10px;
  text-transform: uppercase;
}

.box-modal h3.title-popup {
  font-size: 5vh;
  margin-top: 0.5rem;
  font-weight: 600;
}
.img-box {
  height: 32vh;
}
.txt-desc {
  font-size: 4vh;
}
.close-pop {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  width: 28px;
  height: 27px;
  fill: #fff;
  background: #00002e8f;
  border-radius: 13px;
  z-index: 30;
}
.btn-defaultx,
.btn-defaultx-list {
  background: #3bad00;
  border-radius: 18px;
  border: #ffffff 3px solid;
  margin: auto;
  text-transform: uppercase;
}
.btn-defaultx-list {
  box-shadow: 0px 0px 6px #00000073;
}
.inform .btn-defaultx {
  width: 68% !important;
  position: absolute;
  bottom: -3.2rem;
  left: 0;
  right: 0;
}
.service,
.inform {
  margin-top: 1.5rem;
  /* padding: 0.5rem; */
  background: #00003d87;
  border-radius: 7px;
  height: calc(100vh - 7.5rem);
  overflow: scroll;
}
.service {
  margin-top: 8.5rem;
  height: calc(100vh - 14.5rem);
}
.head-service {
  background-image: url("../assets/knopi.png");
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  width: 100%;
  min-width: 11rem !important;
  max-width: 30rem;
  height: 12rem;
  top: -146px;
  z-index: 20;
}
.inform {
  height: calc(100vh - 9.5rem);
}
.box-list {
  padding: 0.5rem;
  color: #767676;
  font-weight: 700;
  border-radius: 7px;
  margin: 0.5rem;
  background-color: #fff;
  position: relative;
  padding-bottom: 1rem;
  text-transform: none;
}
.head-service {
  background-image: url("../assets/knopi.png");
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  width: 100%;
  min-width: 11rem !important;
  max-width: 30rem;
  height: 12rem;
  top: -130px;
  z-index: 20;
}
.head-list {
  background: #004ec1;
  background-image: url("../assets/coins.png");
  background-repeat: no-repeat;
  background-size: cover;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
  padding-bottom: 1rem;
  color: #fff;
  position: relative;
  padding-top: 2rem;
  margin: -0.5rem;
  margin-bottom: 1rem;
}
.head-list-desc {
  display: inline-block;
  background: #000000a8;
  padding: 0.5rem 1rem;
  font-weight: 100;
  font-size: 15px;
  border-radius: 9px;
}
#popupInfo {
  width: 90vw;
  max-width: 41rem;
}
@keyframes modalshow {
  0% {
    top: 400px;
  }
  100% {
    top: 0px;
  }
}
.main-pop.show .box-modal {
  animation-name: modalshow;
  animation-duration: 1s;
}

/* ===============================================================
   CELL CARD PORTRAIT → LANDSCAPE ROTATION
   =============================================================== */

.main-pop.show.main-pop--landscape {
  position: fixed !important;

  top: 0 !important;

  left: 0 !important;

  width: 100vw !important;

  height: 100vh !important;

  display: flex !important;

  align-items: center !important;

  justify-content: center !important;
}

.main-pop.main-pop--landscape {
  display: none;
}

.main-pop--landscape .backdrop-pop {
  position: fixed !important;

  top: 0 !important;

  left: 0 !important;

  width: 100vw !important;

  height: 100vh !important;
}

.main-pop--landscape .box-modal {
  position: relative !important;

  width: 90vh !important;

  max-width: none !important;

  height: auto !important;

  max-height: 90vw !important;

  margin: auto !important;

  transform: rotate(90deg) !important;

  transform-origin: center center !important;
}

.main-pop--landscape .box-modal .d-block {
  max-height: 90vw !important;

  overflow-y: auto !important;

  overflow-x: hidden !important;
}

.main-pop--landscape .title-popup,
.main-pop--landscape .txt-desc,
.main-pop--landscape .box-list,
.main-pop--landscape .box-list div,
.main-pop--landscape .head-list-desc,
.main-pop--landscape .btn-defaultx,
.main-pop--landscape .btn-defaultx-list {
  word-break: break-word !important;

  overflow-wrap: break-word !important;

  white-space: normal !important;
}

.main-pop--landscape .box-modal h3.title-popup {
  font-size: 3.5vh !important;
}

.main-pop--landscape .txt-desc {
  font-size: 2.8vh !important;
}

.main-pop--landscape .img-box {
  max-height: 28vw !important;

  height: auto !important;

  width: auto !important;
}

.main-pop--landscape .service,
.main-pop--landscape .inform {
  height: auto !important;

  max-height: 55vw !important;

  overflow-y: auto !important;

  margin-top: 1rem !important;
}

.main-pop--landscape .inform .btn-defaultx {
  position: relative !important;

  bottom: auto !important;

  width: 68% !important;

  margin-top: 1rem !important;
}

.popup-logout {
  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: flex-start;

  text-align: center;
}

.popup-logout .title-popup {
  margin: 0 0 0.5rem 0;
}

.popup-logout .txt-desc {
  margin: 0 0 1rem 0;
}

.popup-logout .title-popup,
.popup-logout .txt-desc {
  width: 100%;

  text-align: center;
}

.logout-buttons {
  display: flex;

  flex-direction: column;

  align-items: center;

  gap: 0.5rem;

  width: 100%;

  margin: 0;
}

.logout-buttons .btn-cancel {
  background: #6c757d;
}

.logout-buttons .btn-confirm {
  background: #3bad00;
}

/* compact logout popup only in rotated landscape mode */
.main-pop--landscape .box-modal:has(.popup-logout) {
  height: auto !important;

  min-height: auto !important;

  max-height: 90vh !important;

  padding-top: 1.5rem !important;

  padding-bottom: 1.5rem !important;
}

.main-pop--landscape .close-pop {
  position: absolute !important;

  top: 0.5rem !important;

  right: 0.5rem !important;

  z-index: 2147483647 !important;

  pointer-events: auto !important;
}
</style>
